export default "__VITE_ASSET__DaaHTT0c__"